// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__247xH","label":"styles_label__3RbDp"};